import Hundiowidget from '@/components/hundioWidget'
import CtaLink from '@/components/ui/cta-link'
import colors from '@/constants/colors'
import { useTranslations } from '@/utils/locale'

interface CloudStatusProps {
  className: string
}

export default function CloudStatus({ className }: CloudStatusProps): JSX.Element {
  const { t } = useTranslations()
  return (
    <div className={`[h2]:m-0 bg-secondary-50 rounded-3xl ${className}`}>
      <h3 className="text-2xl mb-0">{t('Cloud Status')}</h3>
      <div>
        <Hundiowidget />
      </div>
      <CtaLink backgroundColor={colors.transparent} to="https://status.bitwarden.com/">
        {t('Check status')}
      </CtaLink>
    </div>
  )
}
